import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getSampleCurrencyFormat } from "../../../utils/utils";
import { apiHandler } from "../../../api";
import { endpoint } from "../../../api/endpoint";
import { GENERATE_HASH, PLACE_ORDER } from "../../../assets/graphql";
import { useNavigate, useParams } from "react-router-dom";

const Checkout_Right_block = ({ showCheckoutform, hideCheckoutform, paymentData }) => {
  const { token } = useSelector((state) => state.login);
  const { addtoproductcart, cartPrices, shippingAddresses, landingData } = useSelector(
    (state) => state.home
  );
  // const getTotalAmount = () => {
  //     let totalPrice = 0;
  //     addtoproductcart && addtoproductcart.forEach(cartitem => {
  //         if (cartitem && cartitem.prices && cartitem.prices.price && cartitem.prices.price.value) {
  //             totalPrice = totalPrice + (cartitem.quantity * cartitem.prices.price.value);
  //         }
  //     });
  //     return addtoproductcart[0] ? getSampleCurrencyFormat("INR", totalPrice) : "0.00";
  // };



  const getShippingAmount = () => {
    let shipping = 0;
    shippingAddresses &&
      shippingAddresses.forEach((shipping_amount) => {
        shipping =
          shipping_amount &&
            shipping_amount.selected_shipping_method &&
            shipping_amount.selected_shipping_method.amount &&
            shipping_amount.selected_shipping_method.amount.value
            ? shipping_amount &&
            shipping_amount.selected_shipping_method &&
            shipping_amount.selected_shipping_method.amount &&
            shipping_amount.selected_shipping_method.amount.value
            : 0;
      });
    return getSampleCurrencyFormat("INR", shipping ? shipping : 0);
  };
  const checkoutProcess = async () => {
    let invalidItem = false;
    addtoproductcart && addtoproductcart.forEach(cartitem => {

      if (cartitem && cartitem.errors && cartitem.errors[0] && cartitem.errors[0].code && cartitem.errors[0].code === 'ITEM_QTY')
      {
        invalidItem = true;
      }
    });
    if (invalidItem) {
      toast.error("please remove invalid item");
      return;
    }
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: {
          c_firstname: paymentData.c_firstname,
          grand_total: cartPrices.grand_total.value,
          email: paymentData.email,
          s_firstname: paymentData.s_firstname,
          s_lastname: paymentData.s_lastname,
          s_street_1: paymentData.s_street_1,
          s_street_2: paymentData.s_street_2,
          s_city: paymentData.s_city,
          s_postcode: paymentData.s_postcode,
          s_state: paymentData.s_state,
          s_country: paymentData.s_country,
          s_phone: paymentData.s_phone,
          b_firstname: paymentData.b_firstname,
          b_lastname: paymentData.b_lastname,
          b_street_1: paymentData.b_street_1,
          b_street_2: paymentData.b_street_2,
          b_city: paymentData.b_city,
          b_postcode: paymentData.b_postcode,
          b_state: paymentData.b_state,
          b_country: paymentData.b_country,
          b_phone: paymentData.b_phone,
          item: paymentData.item,
        },
        query: GENERATE_HASH,
      },
    });

    // PLACE ORDER
    const resultOrder = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      authToken: token,
      method: "POST",
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: {
          cart_id: paymentData.cart_id,
          unique_merchant_txn_id: result.data.generatePinelabsHash.merchant_transaction_id,
        },
        query: PLACE_ORDER,
      },
    });
    if (!resultOrder.data.placeOrder) {
      if (resultOrder.data.message) toast.error(resultOrder.data.message);
      else toast.error("Error in placing Order. Please try again !");
    } else {
      openPaymentURL(result.data.generatePinelabsHash);
    }
  };
  const openPaymentURL = (paymentData) => {
    if (paymentData.response_code == "1") {
      // console.log(paymentData.response_code);
      window.location.href = paymentData.redirect_url;
      // console.log(paymentData.redirect_url);
    } else toast.error(paymentData.response_message);
  };

  const getProductDiscount = () => {
    let totalDiscount = 0;

    cartPrices &&
      cartPrices.discounts &&
      cartPrices.discounts.forEach((element) => {
        const value =
          element && element.amount && element.amount.value
            ? element && element.amount && element.amount.value
            : 0;

        totalDiscount = value;
      });

    return getSampleCurrencyFormat("INR", totalDiscount);
  };
  return (
    <>
      <div className="cart_right_block">
        <div className="cart_subtotal_block">
          <ul>
            {/* <li>
              <label for="">Price</label>
              <span>
                {getSampleCurrencyFormat(
                  "INR",
                  cartPrices &&
                    cartPrices &&
                    cartPrices.subtotal_excluding_tax &&
                    cartPrices.subtotal_excluding_tax.value
                    ? cartPrices &&
                    cartPrices &&
                    cartPrices.subtotal_excluding_tax &&
                    cartPrices.subtotal_excluding_tax.value
                    : "0"
                )}
              </span>{" "}
            </li>
            <li>
              <label for="">Discount</label>
              <span>{getProductDiscount()}</span>{" "}
            </li>
            <li>
              <label for="">Delivery Charges</label>
              <span>{getShippingAmount()}</span>{" "}
            </li> */}
            <li>
            <div className='amount-div'>

              <label for="">Total Amount</label>
              <br/>
               <span>(Incl. of all taxes)</span>
              </div>
              <span>
                {" "}
                {getSampleCurrencyFormat(
                  "INR",
                  cartPrices &&
                    cartPrices &&
                    cartPrices.grand_total &&
                    cartPrices.grand_total.value
                    ? cartPrices &&
                    cartPrices &&
                    cartPrices.grand_total &&
                    cartPrices.grand_total.value
                    : "0"
                )}
              </span>{" "}
            </li>
            {landingData.company[0].checkoutpage_text &&
            <li className="saving_info">
              <p dangerouslySetInnerHTML={{ __html: landingData.company[0].checkoutpage_text }}></p>
            </li>}
          </ul>
        {cartPrices.grand_total.value === 0 ? "" :       
        <>
        {showCheckoutform ? (
            <>
              <div className="procede_cart">
                <div className="proceede_btn">
                  {" "}
                  <button
                    className="continuebutton"
                    disabled={!showCheckoutform}
                    onClick={() => checkoutProcess()}
                  >
                    Checkout
                  </button>{" "}
                </div>
              </div>
            </>
          ) : (
            <div className="procede_cart">
              <div className="proceede_btn">
                {" "}
                <button
                  className="continuebutton"
                  disabled={true}
                  onClick={() => checkoutProcess()}
                >
                  Checkout
                </button>{" "}
              </div>
            </div>
          )}
        </>  }   
        </div>
      </div>
    </>
  );
};

export default Checkout_Right_block;
